module.exports = __webpack_public_path__ + "static/img/m16.2498a41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/mobile/m16.png
// module id = +BM8
// module chunks = 12